import styled from "@emotion/styled";
import Constants from "segments/desktop/core-components/reviews/constants";
import { TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
export const StyledReviews = styled.div`
  display: flex;

  .review-card-component-wrapper {
    flex-shrink: 0;

    &:not(:last-child) {
      margin-right: ${Constants.REVIEW_CARD_MARGIN}px;
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    flex-direction: column;

    .review-card-component-wrapper {
      &:not(:last-child) {
        margin-right: 0;
        margin-bottom: ${Constants.REVIEW_CARD_MARGIN}px;
      }
    }
  }
`;
